export default __webpack_public_path__ + "static/GokceLopes-1ee564f28c9db0d2ea2ec6b87b96360a.png";